/* Zenflow Active — collection colour picker */
const FAMILIES = [
  ['Black', '#111', /black|ebony|onyx|jet/],
  ['Grey', '#8a8c97', /gr[ae]y|charcoal|ash|smoke|silver|slate|graphite|stone/],
  ['White & cream', '#f1ede4', /white|cream|ivory|beige|apricot|nude|oat|sand|khaki|camel|milk|vanilla|ecru|taupe/],
  ['Pink', '#e7a2b4', /pink|rose|blush|peach|coral|salmon|fuchsia|magenta|watermelon|candy/],
  ['Red', '#b8323a', /red|wine|burgundy|maroon|claret|cherry|berry/],
  ['Purple', '#8a63b8', /purple|violet|lilac|lavender|grape|plum|mauve|orchid|taro/],
  ['Blue', '#3f6fc4', /blue|navy|denim|cobalt|sky|azure|teal|turquoise|aqua|cyan|indigo|royal/],
  ['Green', '#4f8a5b', /green|olive|sage|mint|army|emerald|forest|matcha|avocado|lime/],
  ['Brown', '#7a5236', /brown|coffee|chocolate|mocha|caramel|tan|rust|cinnamon|brick|cocoa/],
  ['Yellow & orange', '#e3a93a', /yellow|mustard|orange|gold|amber|lemon|ginger/],
];
const familyOf = (n) => { n = String(n).toLowerCase(); for (const [f, , re] of FAMILIES) if (re.test(n)) return f; return null; };
const slug = (s) => s.toLowerCase().replace(/&/g, 'and').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

function init(root) {
  if (root.dataset.zfCpReady) return;
  root.dataset.zfCpReady = '1';
  let products;
  try { products = JSON.parse(root.querySelector('[data-zf-cp-data]').textContent); } catch (e) { return; }
  const chips = root.querySelector('[data-zf-cp-chips]');
  const status = root.querySelector('[data-zf-cp-status]');
  const grid = root.querySelector('[data-zf-cp-grid]');
  const mainGrid = document.querySelector('.product-grid-container')?.closest('.shopify-section');

  const counts = new Map();
  const items = products.map((p) => {
    const map = new Map();
    for (const [name, src, url, avail] of p.s || []) {
      const f = familyOf(name);
      if (!f) continue;
      const cur = map.get(f);
      if (!cur || (!cur.avail && avail)) map.set(f, { name, src, url, avail });
    }
    map.forEach((_, f) => counts.set(f, (counts.get(f) || 0) + 1));
    return { p, map };
  });
  const fams = FAMILIES.filter(([f]) => (counts.get(f) || 0) >= 2);
  if (fams.length < 2) return;

  const mk = (label, fam, dot) => {
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'zf-cp__chip';
    b.dataset.fam = fam || '';
    b.setAttribute('aria-pressed', fam ? 'false' : 'true');
    if (dot) b.innerHTML = `<span class="zf-cp__dot" style="--dot:${dot}" aria-hidden="true"></span>`;
    b.append(document.createTextNode(fam ? `${label} (${counts.get(fam)})` : label));
    return b;
  };
  chips.append(mk('All colours', null, null));
  fams.forEach(([f, dot]) => chips.append(mk(f, f, dot)));
  root.hidden = false;

  const render = (fam) => {
    const hits = items.filter((it) => it.map.has(fam));
    grid.innerHTML = hits.map(({ p, map }) => {
      const h = map.get(fam);
      const sold = !h.avail;
      const price = p.c ? `${esc(p.p)} <s>${esc(p.c)}</s>` : esc(p.p);
      return `<li><article class="zf-card">
        <div class="zf-card__stage"><a class="zf-card__media" href="${esc(h.url)}" aria-label="${esc(p.t)} in ${esc(h.name)}">
          <img src="${esc(h.src)}" alt="${esc(p.t)} in ${esc(h.name)}" loading="lazy" width="600" height="750">
          ${sold ? '<span class="zf-card__soldout">Sold out</span>' : ''}</a></div>
        <a class="zf-card__title" href="${esc(h.url)}">${esc(p.t)}</a>
        <div class="zf-cp__meta"><span class="zf-card__price">${price}</span><span class="zf-cp__shown">Shown in ${esc(h.name)}</span></div>
      </article></li>`;
    }).join('');
    return hits.length;
  };

  const apply = (fam, push) => {
    chips.querySelectorAll('.zf-cp__chip').forEach((c) => c.setAttribute('aria-pressed', String((c.dataset.fam || null) === fam)));
    if (fam) {
      const n = render(fam);
      grid.hidden = false;
      if (mainGrid) mainGrid.hidden = true;
      status.textContent = `${n} ${n === 1 ? 'piece' : 'pieces'} in ${fam.toLowerCase()}`;
    } else {
      grid.hidden = true; grid.innerHTML = '';
      if (mainGrid) mainGrid.hidden = false;
      status.textContent = '';
    }
    const on = chips.querySelector('[aria-pressed="true"]');
    if (on && chips.scrollWidth > chips.clientWidth) chips.scrollLeft = on.offsetLeft - chips.offsetLeft - 16;
    if (push) {
      const u = new URL(location.href);
      if (fam) u.searchParams.set('colour', slug(fam)); else u.searchParams.delete('colour');
      history.replaceState(null, '', u);
    }
  };

  chips.addEventListener('click', (e) => {
    const b = e.target.closest('.zf-cp__chip');
    if (b) apply(b.dataset.fam || null, true);
  });
  const want = new URL(location.href).searchParams.get('colour');
  const start = want && fams.find(([f]) => slug(f) === want);
  if (start) apply(start[0], false);
}

const boot = (s = document) => s.querySelectorAll('[data-zf-cp]').forEach(init);
boot();
document.addEventListener('shopify:section:load', (e) => boot(e.target));
